const initialValue = {
  customerinvoicesOptions: [],
  selectedInvoices: [],
}

export default initialValue
